import { Button as MUIButton, ButtonProps } from "@mui/material";
import "./styles.css";
import styled from "@emotion/styled";

const StyledButton = styled(MUIButton)`
  background: rgb(73, 69, 255);
  fontsize: 10px;
  padding: 8px 12px;
  height: 32px;
  fontsize: 20px;
`;

interface Props extends ButtonProps {
  handleClick?: () => void;
  children?: any;
  className?: string;
}

export default function Button({
  handleClick,
  children,
  className,
  style,
  disabled,
  ...restProps
}: Props) {
  return (
    <StyledButton
      className={`buttonContainer ${className} ${
        disabled ? "buttonDisabled" : ""
      }`}
      onClick={handleClick}
      disabled={disabled}
      variant="contained"
      {...restProps}
    >
      {children}
    </StyledButton>
  );
}
